import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DashpivotEvent, EventNotifierService, EventTypes } from '@site-mate/dashpivot-shared-library';

import { SegmentService } from 'app/segment/segment.service';

@Component({
  selector: 'cc-identity-cards',
  templateUrl: './identity-cards.component.html',
  styleUrls: ['./identity-cards.component.scss'],
})
export class IdentityCardsComponent implements OnInit {
  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly segmentService: SegmentService,
  ) {}

  ngOnInit(): void {
    const { hierarchy } = this.activatedRoute.snapshot.data;
    void EventNotifierService.notify(
      new DashpivotEvent(EventTypes.UserTypeViewed, {
        Context: 'ID Card User',
        Hierarchy: hierarchy,
      }),
      this.segmentService,
    );
  }
}
